function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as c, jsxs as t } from "react/jsx-runtime";
import { useTheme as n } from "../../hooks.js";
import { useIsInverseVariant as m } from "../../theme-variant-context.js";
import { vars as e } from "../../skins/skin-contract.css-mistica.js";
const s = (_param)=>{
    var { color: h , size: a = 24  } = _param, o = _object_without_properties(_param, [
        "color",
        "size"
    ]);
    const r = m(), l = h !== null && h !== void 0 ? h : r ? e.colors.inverse : e.colors.neutralHigh, { skinName: i  } = n();
    return i.match(/^o2/i) ? /* @__PURE__ */ c("svg", _object_spread_props(_object_spread({
        width: a,
        height: a,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, o), {
        children: /* @__PURE__ */ c("path", {
            fill: l,
            d: "M6.644 2H17.36c1.18 0 2.145.965 2.14 2.144V22h-15V4.144C4.5 2.96 5.465 2 6.644 2zm4.983 4.823h-.365a.533.533 0 00-.535.535c0 .297.237.535.535.535h.365a2.682 2.682 0 002.625 2.144 2.62 2.62 0 001.22-.302.534.534 0 00.233-.722.534.534 0 00-.722-.234 1.532 1.532 0 01-.727.183c-.7 0-1.284-.448-1.508-1.07h1.673a.533.533 0 00.535-.534.533.533 0 00-.535-.535h-1.673a1.604 1.604 0 011.508-1.07c.247 0 .494.064.727.183a.538.538 0 00.722-.233.538.538 0 00-.233-.722 2.634 2.634 0 00-1.22-.302 2.682 2.682 0 00-2.625 2.144zm4.302 11.072c.298 0 .54-.238.54-.535a.533.533 0 00-.535-.535H8.075a.533.533 0 00-.535.535c0 .297.238.535.535.535h7.854zm-7.854-3.57h7.854c.298 0 .54-.238.54-.535a.533.533 0 00-.535-.535H8.075a.533.533 0 00-.535.535c0 .297.238.535.535.535z"
        })
    })) : /* @__PURE__ */ t("svg", _object_spread_props(_object_spread({
        width: a,
        height: a,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, o), {
        children: [
            /* @__PURE__ */ c("path", {
                fill: l,
                d: "M7.76 7.345V8.83c1.196.202 1.453.913 1.448 1.485 0 .476-.174.876-.502 1.162-.243.21-.568.35-.952.41v.383a.42.42 0 11-.84 0v-.378a2.875 2.875 0 01-1.227-.48.408.408 0 01-.19-.352.4.4 0 01.403-.398c.095.003.185.03.26.084.23.16.488.274.756.345V9.518C5.852 9.292 5.62 8.626 5.62 8.082c0-.815.495-1.38 1.296-1.526V6.07a.42.42 0 11.84 0v.476c.35.048.676.16.94.322.198.123.229.283.229.367a.39.39 0 01-.39.39.515.515 0 01-.23-.065L8.3 7.558a2.153 2.153 0 00-.54-.213zm-.84.012c-.32.106-.5.347-.5.689 0 .232.07.479.5.63v-1.32zm.84 2.3v1.44c.411-.104.655-.373.655-.754 0-.275-.09-.544-.655-.687z"
            }),
            /* @__PURE__ */ c("path", {
                fill: l,
                d: "M21.84 7.9v-.008c0-.014 0-.026-.002-.04v-.014l-.008-.05-.007-.026a.201.201 0 01-.005-.019.018.018 0 00-.003-.01l-.002-.004a.095.095 0 00-.01-.024l-.004-.012-.006-.011a.334.334 0 00-.022-.045v-.003l-.025-.042-.009-.011a.491.491 0 01-.01-.016l-.012-.015-.009-.011c-.01-.014-.022-.025-.033-.037L16.49 2.32a.43.43 0 00-.037-.033l-.01-.009a.784.784 0 00-.032-.022l-.01-.009-.043-.025-.022-.011-.023-.011-.011-.006a.139.139 0 00-.036-.011l-.014-.003a.237.237 0 00-.048-.011l-.05-.008h-.015c-.014-.003-.027-.006-.041-.006h-.009l-4.028.002c-1.723.001-3.194.002-3.56.004-.726 0-1.177.45-1.177 1.17v.748c-1.627.003-2.902.435-3.781 1.283-.919.883-1.384 2.196-1.384 3.897 0 1.7.465 3.01 1.384 3.896.88.849 2.151 1.28 3.781 1.283v6.227c0 .364.107.658.314.868.207.21.499.317.866.317H20.69c.708 0 1.15-.446 1.154-1.157-.002-.227-.002-2.303-.002-4.884L21.841 7.9zm-14.5 5.448c-2.754 0-4.09-1.339-4.09-4.092 0-2.754 1.339-4.093 4.09-4.093 1.44 0 2.459.317 3.114.972.656.656.975 1.675.975 3.12 0 2.757-1.339 4.093-4.09 4.093zm3.067 4.944a.562.562 0 01-.56-.56c0-.308.252-.56.56-.56h8.036a.56.56 0 01.003 1.12h-8.04zm8.039-3.277h-6.737a.562.562 0 01-.56-.56c0-.308.252-.56.56-.56h6.737c.308 0 .56.252.56.56 0 .308-.252.56-.56.56zm-4.552-3.277a.562.562 0 01-.56-.56c0-.309.252-.56.56-.56h4.552a.561.561 0 010 1.12h-4.552zm4.207-4.398c-.479-.003-.829-.16-1.067-.485-.238-.325-.37-.815-.372-1.414V4.07l3.266 3.269H18.1z"
            })
        ]
    }));
}, z = s;
export { z as default };
